import { render } from "./finalFeedback.vue?vue&type=template&id=305cfdfe&scoped=true"
import script from "./finalFeedback.vue?vue&type=script&lang=js"
export * from "./finalFeedback.vue?vue&type=script&lang=js"

import "./finalFeedback.vue?vue&type=style&index=0&id=305cfdfe&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-305cfdfe"]])

export default __exports__